import { render, staticRenderFns } from "./RelatedVehicleDataUnitTemplateAgent.vue?vue&type=template&id=17243790&scoped=true&"
import script from "./RelatedVehicleDataUnitTemplateAgent.vue?vue&type=script&lang=ts&"
export * from "./RelatedVehicleDataUnitTemplateAgent.vue?vue&type=script&lang=ts&"
import style0 from "./RelatedVehicleDataUnitTemplateAgent.vue?vue&type=style&index=0&id=17243790&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17243790",
  null
  
)

export default component.exports